<template>
    <div class="meuModal show" v-show="mostrar">
        <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header mb-2" v-if="usarHeader">
                    <slot name="header" />
                </div>
                <div class="modal-body mb-2 d-flex g-3">
                    <slot name="corpo" />
                </div>
                <div class="modal-footer" v-if="usarFooter">
                    <slot name="rodape" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import store from '@/store/store';
import { reactive, onMounted, computed, defineProps, defineEmits } from 'vue';

const props = defineProps(['mostrar', 'usarHeader', 'usarFooter', 'usarCronometro']);

const emits = defineEmits(['fechar']);

onMounted(() => {
    if (props.usarCronometro)
        cronometro();
});

function cronometro() {
    setTimeout(() => {
        setInterval(() => {
            if (props.mostrar) {
                emits("fechar");
            }
        }, 1000 * config.value.atualizacao);
    }, 2000);
}
const config = computed(() => {
    return store.state.config;
});
</script>

<style scoped>
.meuModal {
    --bs-modal-width: 500px;
    --bs-modal-padding: 1rem;
    --bs-modal-margin: 0.5rem;
    --bs-modal-color: ;
    --bs-modal-bg: #fff;
    --bs-modal-border-color: var(--bs-border-color-translucent);
    --bs-modal-border-width: 1px;
    --bs-modal-border-radius: 0.5rem;
    --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    --bs-modal-inner-border-radius: calc(0.5rem - 1px);
    --bs-modal-header-padding-x: 1rem;
    --bs-modal-header-padding-y: 1rem;
    --bs-modal-header-padding: 1rem 1rem;
    --bs-modal-header-border-color: var(--bs-border-color);
    --bs-modal-header-border-width: 1px;
    --bs-modal-title-line-height: 1.5;
    --bs-modal-footer-gap: 0.5rem;
    --bs-modal-footer-bg: ;
    --bs-modal-footer-border-color: var(--bs-border-color);
    --bs-modal-footer-border-width: 1px;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
}

.modal-body,
.modal-footer {
    justify-content: center;
    flex-direction: column;
    /* align-items: flex-end; */
}
</style>